import React, { useState } from "react";

const CustomAccordion = ({
    title,
    children,
    defaultExpanded = false,
    className = "",
    buttonClassName = "",
    iconClassName = "w-7 h-7",
    count = 0,
    open,
    onClick,
    showHeader = null,
    // headerContent = null,
}) => {
    // const [open, setOpen] = useState(defaultExpanded);

    return (
        <div
            className={`border-b border-solid border-gray-200 overflow-hidden w-full rounded-md ${className}`}
        >
            {/* Header */}
            <button
                onClick={onClick}
                className={`w-full flex justify-between items-center px-4 py-3 text-left hover:bg-gray-300 transition cursor-pointer ${
                    open ? "bg-gray-200" : ""
                } ${buttonClassName}`}
            >
                {showHeader ? (
                    showHeader
                ) : (
                    <>
                        <span>{title}</span>
                        <div className="flex items-center md:gap-4 gap-2">
                            {count > 0 && (
                                <span className="text-primary text-sm font-medium">
                                    {count}{" "}
                                    {count === 1 ? "Parameter" : "Parameters"}
                                </span>
                            )}

                            <svg
                                className={`${iconClassName} transform transition-transform duration-200 text-primary ${
                                    open ? "rotate-180" : "rotate-0"
                                }`}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </div>
                    </>
                )}
            </button>

            {/* Content */}
            <div
                className={`px-2 overflow-hidden transition-all duration-300 ease-in-out ${
                    open ? "max-h-max py-3" : "max-h-0 py-0"
                }`}
            >
                <div className="text-sm text-gray-700">{children}</div>
            </div>
        </div>
    );
};

export default CustomAccordion;
